module.exports = __webpack_public_path__ + "static/media/logo_chi.457cbf68.svg";